<template>
<div class="actions">
  <button class="button is-small is-fullwidth"
    @click="requestAutoAdjust()"
    :disabled="ongoingHistogramExtraction || waitingForHistogram"
  >
    {{$t('button-auto')}}
  </button>
  <cytomine-slider
    :value="bounds.max"
    @input="setMaxBound"
    :max="defaultBounds.max"
    :lazy="false"
    :tooltip="false"
    :contained="true"
    :height="150"
    direction="btt"
    size="is-small"
    class="slider"
  />
  <button class="button is-small is-fullwidth" @click="reset()" :disabled="areBoundsReset">
    {{$t('button-reset')}}
  </button>
</div>
</template>

<script>

import CytomineSlider from '@/components/form/CytomineSlider.vue';
import {autoAdjustedBounds, DEFAULT_BOUNDS, sameHistogramBounds} from '@/utils/histogram-utils';
import constants from '@/utils/constants';

export default {
  name: 'histolog-contrast-panel',
  components: {CytomineSlider},
  props: {
    index: String
  },
  data() {
    return {
      waitingForHistogram: false,
    };
  },
  computed: {
    imageModule() {
      return this.$store.getters['currentProject/imageModule'](this.index);
    },
    imageWrapper() {
      return this.$store.getters['currentProject/currentViewer'].images[this.index];
    },
    defaultBounds() {
      return DEFAULT_BOUNDS;
    },
    bounds: {
      get() {
        return this.imageWrapper.colorOverlay.bounds;
      },
      set(value) {
        this.$store.commit(this.imageModule + 'setBounds', value);
      }
    },
    ongoingHistogramExtraction() {
      return this.imageWrapper.colorOverlay.ongoingHistogramExtraction;
    },
    histogram() {
      return this.imageWrapper.colorOverlay.histogram;
    },
    pixelCount() {
      return this.imageWrapper.colorOverlay.pixelCount;
    },
    areBoundsReset() {
      return sameHistogramBounds(this.bounds, DEFAULT_BOUNDS);
    },
  },
  watch: {
    ongoingHistogramExtraction(value) {
      if (!value && this.waitingForHistogram) {
        this.applyAutoAdjust();
      }
    }
  },
  methods: {
    requestAutoAdjust() {
      // Update ongoingHistogramExtraction behind the scene
      this.$store.dispatch(this.imageModule + 'startHistogramExtraction');
      this.waitingForHistogram = true;
    },
    applyAutoAdjust() {
      this.bounds = autoAdjustedBounds(
        this.histogram, {
          saturation: constants.AUTO_ADJUST_SATURATED,
          pixelCount: this.pixelCount
      });
      this.waitingForHistogram = false;
    },
    reset() {
      this.bounds = DEFAULT_BOUNDS;
    },
    setMaxBound(maxBound) {
      this.bounds = {...DEFAULT_BOUNDS, max: maxBound};
    }
  }
}
</script>

<style scoped>
.actions {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.slider {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>
